import { useWizardStore } from './store';

export const useWizard = () => {
  const data = useWizardStore((state) => state.data);
  const setData = useWizardStore((state) => state.setData);

  const resetData = () => useWizardStore.persist.clearStorage();

  return { data, setData, resetData };
};
